import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Table } from 'reactstrap'
import { enterKeyHandler } from '../../utils'
import '../CustomCode/Custom.css'
import CustomSelectListInput from '../CustomCode/CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomCode/CustomUtils'
import FormHeading from '../CustomCode/FormHeading'
import FormSubmitButton from '../CustomCode/FormSubmitButton'
import TextInput from '../CustomCode/TextInput'
import useForm from '../CustomHooks/FormHook'
import './Picklist.css'


export default function PicklistForm({ location }) {
  console.log('PicklistForm rendered: ', location)

  let init = {
    picklistName: '',
    pluralName: '',
    choiceTableName: '',
    choicePKName: '',
    choiceDisplayName: '',
    cardId: '',
    newFieldObjectTypeId: '',
    fieldName: '',
    fieldColumnName: ''
  }

  function handlePickListNameChange(pickListEvent) {
    console.log('event inside handlePickListNameChange',pickListEvent)
    const pluralNameEvent = {target: { name: 'pluralName', value: pickListEvent.target.value }}
    handleInputChange(pluralNameEvent)

    const choiceTableNameEvent = {target: { name: 'choiceTableName', value: pickListEvent.target.value }}
    choiceTableNameEvent.target.value = 'tb_' + choiceTableNameEvent.target.value.replace(/ /g, '_').toLowerCase()
    handleInputChange(choiceTableNameEvent)

    const pkColumnNameEvent = {target: { name: 'choicePKName', value: pickListEvent.target.value }}
    pkColumnNameEvent.target.value = pkColumnNameEvent.target.value.replace(/ /g, '_').toLowerCase() + '_id'
    handleInputChange(pkColumnNameEvent)

    const choiceDisplayNameEvent = {target: { name: 'choiceDisplayName', value: pickListEvent.target.value }}
    choiceDisplayNameEvent.target.value = choiceDisplayNameEvent.target.value.replace(/ /g, '_').toLowerCase() + '_name'
    handleInputChange(choiceDisplayNameEvent)
    
    const fieldNameEvent = {target: { name: 'fieldName', value: pickListEvent.target.value }}
    handleInputChange(fieldNameEvent)

    const fieldColumnNameEvent = {target: { name: 'fieldColumnName', value: pickListEvent.target.value.replace(/ /g, '_').toLowerCase() }}
    handleInputChange(fieldColumnNameEvent)

    handleInputChange(pickListEvent)
    setRefresh(pickListEvent)
  }

  function submitAndRefresh(event) {
    console.log(refresh)
    handleInputChange(event)
    setRefresh(event)
  }

  const navigate = useNavigate()
  init = initialFormValues('PicklistForm', navigate, init)
  const [refresh, setRefresh] = useState()
  const [formFeedback, setFormFeedback] = useState({})
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  // Scroll error messages into view
  const scrollRef = useRef(null)
  useEffect(() => {
    console.log('userEffect: ', formFeedback, scrollRef)
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [formFeedback])

  async function submitSearch() {
    let badInput = false
    const formFeedbackObject = {
      noPicklistName : null,
      longChoiceTableName: null,
      longPK: null,
      longChoiceColumnName: null,
      longFieldColumnName: null,
      noFieldName: null
    }
    if (!inputs.picklistName) {
      badInput = true
      formFeedbackObject.noPicklistName = <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}><b>Picklist Name</b> must be specified.</Alert></td></tr>
    }
    if (inputs.choiceTableName.length > 30) {
      badInput = true
      formFeedbackObject.longChoiceTableName = <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}><b>Choice Table Name</b> must not be more than 30 characters long.</Alert></td></tr>
    }
    if (inputs.choicePKName.length > 30) {
      badInput = true
      formFeedbackObject.longPK = <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}><b>Choice PK Column Name</b> must not be more than 30 characters long.</Alert></td></tr>
    }
    if (inputs.choiceDisplayName.length > 30) {
      badInput = true
      formFeedbackObject.longChoiceColumnName = <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}><b>Choice Display Column Name</b> must not be more than 30 characters long.</Alert></td></tr>
    }
    if (inputs.choiceTableName.length > 30) {
      badInput = true
      formFeedbackObject.longFieldColumnName = <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}><b>Field Column Name</b> must not be more than 30 characters long.</Alert></td></tr>
    }
    if (inputs.newFieldObjectTypeId && (!inputs.fieldName || !inputs.fieldColumnName)) {
      console.log('inside if')
      badInput = true
      formFeedbackObject.noFieldName = <tr ref={scrollRef}><td colSpan={2}><Alert className='custom-alert' color='danger' style={{ display: 'block', textAlign: 'center', margin: 'auto' }}><b>Field Name and Field Column Name</b> cannot be blank when adding a new field</Alert></td></tr>
    }

    if (badInput) {
      return setFormFeedback(formFeedbackObject)
    }
    setFormFeedback({})

    submitFormValues('PicklistForm', navigate, inputs, 'admin_tools.create_picklist')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText="Create Picklist" />
            <tbody>
              {formFeedback.noPicklistName}
              <TextInput label='Picklist Name' name='picklistName' handleInputChange={(event) => handlePickListNameChange(event)} defaultValue={inputs.picklistName} inputStyle={{ minWidth: '400px' }}  />
              <TextInput label='Plural Form (optional)' name='pluralName' handleInputChange={submitAndRefresh} value={inputs.pluralName} inputStyle={{ minWidth: '400px' }} />
              {formFeedback.longChoiceTableName}
              <TextInput label='Choice Table Name' name='choiceTableName' handleInputChange={submitAndRefresh} value={inputs.choiceTableName} inputStyle={{ minWidth: '400px' }} />
              {formFeedback.longPK}
              <TextInput label='Choice PK Column Name' name='choicePKName' handleInputChange={submitAndRefresh} value={inputs.choicePKName} inputStyle={{ minWidth: '400px' }} />
              {formFeedback.longChoiceColumnName}
              <TextInput label='Choice Display Column Name' name='choiceDisplayName' handleInputChange={submitAndRefresh} value={inputs.choiceDisplayName} inputStyle={{ minWidth: '400px' }} />
              <CustomSelectListInput label="Add Field To" handleChange={handleInputChange} modelName="Admin" entityName="picklist_field_doc_type" name='newFieldObjectTypeId' blankOption={true} defaultValue={inputs.claimNumber} />
              {formFeedback.noFieldName}
              <TextInput label='Field Name' name='fieldName' handleInputChange={submitAndRefresh} value={inputs.fieldName} inputStyle={{ minWidth: '400px' }} />
              {formFeedback.longFieldColumnName}
              <TextInput label='Field Column Name' name='fieldColumnName' handleInputChange={submitAndRefresh} value={inputs.fieldColumnName} inputStyle={{ minWidth: '400px' }} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label="Create Picklist" />
      </form>
    </div>
  )
}

